import { render, staticRenderFns } from "./carouselDigitalSignage.vue?vue&type=template&id=e8575964"
import script from "./carouselDigitalSignage.ts?vue&type=script&lang=js&external"
export * from "./carouselDigitalSignage.ts?vue&type=script&lang=js&external"
import style0 from "./carouselDigitalSignage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports